import { useAuth } from "@/shared/hooks/useAuth";

/**
 * Encapsulates UI-side permission checks. The backend enforces the same rules;
 * these helpers exist purely to hide controls users cannot use.
 */
export const usePermission = () => {
  const { user } = useAuth();
  const roles = user?.roles ?? [];

  const isSystemAdmin = roles.includes("SYSTEM_ADMIN");
  const isSchoolAdmin = roles.includes("SCHOOL_ADMIN");
  const isCounselor = roles.includes("GUIDANCE_COUNSELOR");
  const isAccountant = roles.includes("ACCOUNTANT");

  return {
    isSystemAdmin,
    isSchoolAdmin,
    isCounselor,
    isAccountant,
    /** Counselor accounts may only read; school admins may write. */
    canWriteSchoolData: isSchoolAdmin,
    canManageSchools: isSystemAdmin,
    canViewSchoolPanel: isSchoolAdmin || isCounselor,
    /** Muhasebe/Kayıt modülü — okul yöneticisi + muhasebeci (rehber öğretmen hariç). */
    canViewAccounting: isSchoolAdmin || isAccountant,
    canWriteAccounting: isSchoolAdmin || isAccountant,
  };
};
